import styled from "styled-components";
import colours from "styles/colours";
import { resetButtonStyling } from "styles/commonStyles";

export const DescriptionText = styled.div`
  width: 65%;
`;

export const LearnMore = styled.button`
  ${resetButtonStyling};
  display: block;
  text-decoration: underline;
  font-weight: bold;
  color: black;
  text-underline-offset: 4px;

  &:hover {
    color: ${colours.elexonBlue};
  }
`;
